import { SxProps, Theme } from '@mui/material';
import { mixinSx, sxType } from '@watershed/style/styleUtils';
import { transition } from '../utils';

export const SIDEBAR_BREAKPOINT_WIDTH = 1420;
export const SIDEBAR_EXPANDED_WIDTH = 260;
export const SIDEBAR_COLLAPSED_WIDTH = 56;

export const SKIP_NAV_LINK_CLASS = 'skip-nav-link';

export const getSharedSidebarStyles = (theme: Theme) => {
  const COLORS = {
    BACKGROUND: theme.palette.background.dark,
    BACKGROUND_ACTIVE: theme.palette.grey80,
    BORDER_COLLAPSED: theme.palette.spring,
    BORDER_ACTIVE: theme.palette.spring,
    TEXT_PRIMARY: theme.palette.white,
    TEXT_SECONDARY: theme.palette.surface,
    TEXT_DISABLED: theme.palette.text.disabled,
  };

  // See https://github.com/reach/reach-ui/blob/main/packages/skip-nav/styles.css for reference.
  const skipNavLinkSxProps: SxProps<Theme> = (theme) => ({
    [`& .${SKIP_NAV_LINK_CLASS}`]: {
      border: 0,
      clip: 'rect(0 0 0 0)',
      height: '1px',
      width: '1px',
      margin: '-1px',
      padding: 0,
      overflow: 'hidden',
      position: 'absolute',
      '&:focus': {
        padding: theme.spacing(1, 2),
        position: 'fixed',
        top: theme.spacing(1),
        left: theme.spacing(1),
        zIndex: '1',
        width: 'auto',
        height: 'auto',
        clip: 'auto',
        textDecoration: 'none',
        outline: 'none',
        border: `2px solid ${theme.palette.primary.main}`,
        borderRadius: 1,
      },
    },
  });

  return {
    COLORS,

    logoBarSxProps: mixinSx(
      {
        padding: '8px',
        paddingRight: '16px',
        display: 'flex',
        alignItems: 'center',
        marginBottom: 1,
      },
      skipNavLinkSxProps
    ),

    skipNavLinkTextSxProps: sxType({
      color: (theme) => theme.palette.primary.main,
    }),

    collapseButtonSxProps: sxType((theme) => ({
      marginLeft: 'auto',
      color: COLORS.TEXT_PRIMARY,
      transition: transition('opacity'),
      position: 'relative',
      right: -4,
      padding: '4px',
      '&:focus': {
        color: theme.palette.primary.main,
        backgroundColor: 'transparent',
      },
    })),

    rootSxProps: sxType({
      zIndex: 50,
      gridColumn: 1,
      position: 'fixed',
      display: 'flex',
      flexDirection: 'column',
      height: '100vh',
      backgroundColor: COLORS.BACKGROUND,
      overflowY: 'auto',
      overflowX: 'hidden',
      transition: transition('width', 'box-shadow'),
      '@media print': { display: 'none' },
    }),
  };
};
